import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_URL from '../config';

function AddDeliveryModal({ onClose, onSuccess }) {
  const [customers, setCustomers] = useState([]);
  const [customerId, setCustomerId] = useState('');
  const [pendingOrders, setPendingOrders] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState('');
  const [quantity, setQuantity] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchCustomers();
  }, []);

  useEffect(() => {
    if (customerId) {
      fetchPendingOrders(customerId);
    } else {
      setPendingOrders([]);
      setSelectedOrderId('');
    }
  }, [customerId]);

  const fetchCustomers = async () => {
    try {
      const res = await axios.get(`${API_URL}/get-customers`);
      setCustomers(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchPendingOrders = async (customerId) => {
    try {
      const res = await axios.get(`${API_URL}/get-orders?customerId=${customerId}`);
      // Show ALL orders (pending and completed) for selection
      const orders = res.data;
      setPendingOrders(orders);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCustomerChange = (e) => {
    const id = e.target.value;
    setCustomerId(id);
    setSelectedOrderId('');
    setQuantity('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/add-delivery`, {
        customer_id: customerId,
        quantity: parseFloat(quantity),
        delivery_person_id: localStorage.getItem('userId'),
        order_id: selectedOrderId || null
      });
      
      // Show success message with order update info
      if (response.data.message) {
        alert(response.data.message);
      }
      
      onSuccess();
      onClose();
    } catch (err) {
      alert('Error adding delivery: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>Record Delivery</h2>
        <form onSubmit={handleSubmit}>
          <select value={customerId} onChange={handleCustomerChange} required>
            <option value="">Select Customer</option>
            {customers.map(c => <option key={c.id} value={c.id}>{c.name} ({c.phone})</option>)}
          </select>

          {pendingOrders.length > 0 && (
            <div className="order-selection">
              <label>Link to Order (Optional)</label>
              <select value={selectedOrderId} onChange={(e) => setSelectedOrderId(e.target.value)}>
                <option value="">No Order (Regular Delivery)</option>
                {pendingOrders.map(order => (
                  <option key={order.id} value={order.id}>
                    Order #{order.id} - {order.ordered_quantity} kg ({order.status})
                  </option>
                ))}
              </select>
              <small>Order will be marked as COMPLETED after this delivery</small>
            </div>
          )}

          <input 
            type="number" 
            step="0.01" 
            placeholder="Quantity (kg)" 
            value={quantity} 
            onChange={(e) => setQuantity(e.target.value)} 
            required 
          />
          
          <div className="modal-buttons">
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit" disabled={loading}>{loading ? 'Recording...' : 'Record Delivery'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddDeliveryModal;